import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { adminLogin, adminMe, getToken } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin | Ysitien LED";
    if (getToken()) {
      adminMe()
        .then(() => navigate("/admin", { replace: true }))
        .catch(() => {});
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email, password);
      toast.success("Tervetuloa!");
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Kirjautuminen epäonnistui.";
      toast.error(typeof msg === "string" ? msg : "Kirjautuminen epäonnistui.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#07111F] text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-[#22D3EE]"
        >
          <ArrowLeft className="h-4 w-4" /> Etusivulle
        </Link>

        <div className="mt-6 rounded-2xl border border-[#1E2F44] bg-[#0D1B2A] p-8 led-glow-soft">
          <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#22D3EE]/10 border border-[#22D3EE]/30 text-[#22D3EE]">
            <Lock className="h-5 w-5" />
          </div>
          <h1 className="mt-5 font-display text-3xl font-bold">Admin</h1>
          <p className="mt-2 text-sm text-neutral-400">
            Kirjaudu nähdäksesi yhteydenotot ja sähköpostiliidit.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-neutral-400">
                Sähköposti
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@yritys.fi"
                data-testid="admin-email"
                className="mt-2 w-full rounded-md border border-[#1E2F44] bg-[#0A1729] px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:ring-2 focus:ring-[#22D3EE]"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-wider text-neutral-400">
                Salasana
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-password"
                className="mt-2 w-full rounded-md border border-[#1E2F44] bg-[#0A1729] px-4 py-3 text-white placeholder:text-neutral-600 focus:outline-none focus:ring-2 focus:ring-[#22D3EE]"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-[#22D3EE] px-5 py-3 font-bold text-[#07111F] hover:bg-[#67E8F9] transition-all led-glow disabled:opacity-60"
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" /> Kirjaudutaan…
                </>
              ) : (
                "Kirjaudu"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
